import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DetailedDossierStatus } from "../../types/Dossier";

export const getDossierStatus = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierStatus", dossierId],
    queryFn: (): Promise<DetailedDossierStatus> => {
      return fetchWithAuth<DetailedDossierStatus>(
        "getDossierStatus",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
